<router-outlet></router-outlet>
<div class="stripe" *ngIf="showStripe">{{ stripeLabel }}</div>
